import axiosInstance from "./axiosInstance";

export const getQuestionDetails = async (labInternalId, questionId) => {
  const res = await axiosInstance.get(`/labs/${labInternalId}/questions/${questionId}`);
  return res.data; // { title, description, difficulty, marks, lockedAfterSubmission? }
};

export const checkQuestionAccess = async (labInternalId, questionId) => {
  const res = await axiosInstance.get(`/labs/${labInternalId}/questions/${questionId}/access`);
  return res.data; // { authorized: boolean }
};
